<div class="nav">
  <a class="nav__item nav__item_link" routerLink="/">Home</a>
  @for (item of navItems; track $index) {
    @if (item.category) {
      <a class="nav__item nav__item_link" [appCategory]="item.category">{{
        item.label
      }}</a>
    } @else {
      @if (item.route) {
        <a class="nav__item nav__item_link" [routerLink]="item.route">{{
          item.label
        }}</a>
      } @else {
        <span class="nav__item">{{ item.label }}</span>
      }
    }
  }
</div>
